import { RouteObject } from 'react-router-dom';
import { loadable } from '@sib/ui';
import { paths } from '@spendbrain/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.services.root,
    element: loadable(() => import('./pages/ServicesPage')),
  },
  {
    path: paths.services.tab,
    element: loadable(() => import('./pages/ServicesPage')),
  },
];
